import Running from './assets/IconPicker/Running.jsx';
import Heart from './assets/IconPicker/Heart.jsx';
import Medal from './assets/IconPicker/Medal.jsx';
import Checkmark from './assets/IconPicker/Checkmark.jsx';
import Calendar from './assets/IconPicker/Calendar.jsx';
import Apple from './assets/IconPicker/Apple.jsx';
import Dumbbell from './assets/IconPicker/Dumbbell.jsx';
import Dumbbell2 from './assets/IconPicker/Dumbbell-2.jsx';
import Dumbbell3 from './assets/IconPicker/Dumbbell-3.jsx';
import Scale from './assets/IconPicker/Scale.jsx';
import Water from './assets/IconPicker/Water.jsx';
import Wine from './assets/IconPicker/Wine.jsx';
import Alarm from './assets/IconPicker/Alarm.jsx';
import Bicycle from './assets/IconPicker/Bicycle.jsx';
import JumpingRope from './assets/IconPicker/Jumping-rope.jsx';
import Fork from './assets/IconPicker/Fork.jsx';
import Bike from './assets/IconPicker/Bike.jsx';
import NoSmoking from './assets/IconPicker/No-smoking.jsx';
import Juice from './assets/IconPicker/Juice.jsx';
import Sleep from './assets/IconPicker/Sleep.jsx';
import Running2 from './assets/IconPicker/Running-2.jsx';
import ThumbUp from './assets/IconPicker/Thumb-up.jsx';
import ThumbDown from './assets/IconPicker/Thumb-down.jsx';
import Calories from "./assets/IconPicker/Calories.jsx";
import Food from './assets/IconPicker/Food.jsx';
import Steps from './assets/IconPicker/Steps.jsx';
import Stopwatch from './assets/IconPicker/Stopwatch.jsx';
import Weight from './assets/IconPicker/Weight.jsx';
import Goal from './assets/IconPicker/Goal.jsx';



export const iconList = [
  { id: 'calories', name: 'Calories', icon: Calories },
  { id: 'food', name: 'Food', icon: Food },
  { id: 'steps', name: 'Steps', icon: Steps },
  { id: 'stopwatch', name: 'Stopwatch', icon: Stopwatch },
  { id: 'weight', name: 'Weight', icon: Weight },
  { id: 'goal', name: 'Goal', icon: Goal },
  { id: 'running', name: 'Running', icon: Running },
  { id: 'heart', name: 'Heart', icon: Heart },
  { id: 'medal', name: 'Medal', icon: Medal },
  { id: 'checkmark', name: 'Checkmark', icon: Checkmark },
  { id: 'calendar', name: 'Calendar', icon: Calendar },
  { id: 'apple', name: 'Apple', icon: Apple },
  { id: 'dumbbell', name: 'Dumbbell', icon: Dumbbell },
  { id: 'dumbbell-2', name: 'Dumbbell2', icon: Dumbbell2 },
  { id: 'dumbbell-3', name: 'Dumbbell3', icon: Dumbbell3 },
  { id: 'scale', name: 'Scale', icon: Scale },
  { id: 'water', name: 'Water', icon: Water },
  { id: 'wine', name: 'Wine', icon: Wine },
  { id: 'alarm', name: 'Alarm', icon: Alarm },
  { id: 'bicycle', name: 'Bicycle', icon: Bicycle },
  { id: 'jumping-rope', name: 'JumpingRope', icon: JumpingRope },
  { id: 'fork', name: 'Fork', icon: Fork },
  { id: 'bike', name: 'Bike', icon: Bike },
  { id: 'no-smoking', name: 'NoSmoking', icon: NoSmoking },
  { id: 'juice', name: 'Juice', icon: Juice },
  { id: 'sleep', name: 'Sleep', icon: Sleep },
  { id: 'running-2', name: 'Running2', icon: Running2 },
  { id: 'thumb-up', name: 'ThumbUp', icon: ThumbUp },
  { id: 'thumb-down', name: 'ThumbDown', icon: ThumbDown }
];
